import { useQuery } from '@tanstack/react-query'
import { PlusIcon } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { Button, ButtonProps } from '../../../components'
import { popupCenter } from '../../../helpers/popup-center'
import { useCogfy } from '../../../hooks'

type AddGithubButtonProps = {
  onSuccess?: () => void
}

export function AddGithubButton (props: AddGithubButtonProps & ButtonProps) {
  const { onSuccess } = props

  const cogfy = useCogfy()
  const windowRef = useRef<Window | null>(null)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const getGithubAuthUrl = useQuery({
    queryKey: ['getGithubAuthUrl'],
    queryFn: ({ signal }) => cogfy.getGitHubAuthUrl({ provider: 'github' }, { signal })
  })

  const checkPopupClosed = () => {
    if (windowRef.current && windowRef.current.closed) {
      clearInterval(intervalRef.current!)
      intervalRef.current = null
      onSuccess?.()
    }
  }

  const openPopup = () => {
    if (getGithubAuthUrl.data?.authUrl) {
      windowRef.current = popupCenter(getGithubAuthUrl.data.authUrl)
      intervalRef.current = setInterval(checkPopupClosed, 200)
    }
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return (
    <Button
      color={props.color}
      size={props.size || 'sm'}
      disabled={getGithubAuthUrl.isLoading}
      onClick={openPopup}
      className={props.className}
    >
      <PlusIcon size={16} />
      {props.children}
    </Button>
  )
}
